import { MenuIcon } from "lucide-react";
import {
  SidebarInset,
  SidebarProvider,
  useSidebar,
} from "@/core/components/ui/sidebar";
import { WosSidebar } from "./components/wos-sidebar";

function MobileToggle() {
  const { toggleSidebar } = useSidebar();

  return (
    <div className="flex items-center justify-between pl-4 pt-4 md:hidden">
      <MenuIcon
        className="h-6 w-6 cursor-pointer"
        onClick={() => toggleSidebar()}
      />
    </div>
  );
}

/**
 * Shell WOS (PED-12262, Fase 1): sidebar nova + área de conteúdo.
 * A área reservada do painel do agente (Fase 3) será acoplada aqui.
 */
export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-svh max-h-svh overflow-hidden">
      <SidebarProvider className="h-full">
        <WosSidebar />

        {/* O scroll vive dentro do contêiner arredondado de cada página
            (AppContent), para os cantos de raio 32 ficarem fixos na viewport. */}
        <SidebarInset className="h-svh overflow-hidden bg-background">
          <MobileToggle />
          {children}
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
}
